const Tooltip = ({text}) => {
    return (
        <div
            className="absolute text-center rounded-md bg-black text-white px-2 py-0.5 hidden group-hover:block">
            {text}
        </div>
    )
}

export default Tooltip;